import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button,DropdownButton,MenuItem} from 'react-bootstrap'
import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import IframeModal from 'component/element/IframeModal'
import StockStore from 'stores/StockStore';
import '../report.css'
// import { connect } from 'react-redux';

class ReportStockBalanceValue extends Component {
  constructor(props) {
    super(props)
    const optionsRows = [10,20,50,100];

    this.state = {
      data: [],
      dataExcel:[],
      loading: false,
      totalPage: 0,
      activePage: 1,
      defaultRows: 20,
      optionsRows: optionsRows,
      stockType:'tool',
      cat_id:'all',
      sub_cat_id:'all',
      stocktypelists:[],
      categorys:[],
      sub_categorys:[{label:'----- ทั้งหมด -----',value:'all'}],
      sum_cost:'0'
    }
    this.refTableId = 'ReportStockBalanceValue-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getCostPerRow(item) {
    let quantity = item.quantity
    let cost_per_unit = item.cost_per_unit
    let amount = 0
    quantity = (quantity===''||quantity===null||quantity===undefined||isNaN(quantity)?0:quantity)
    cost_per_unit = (cost_per_unit===''||cost_per_unit===null||cost_per_unit===undefined||isNaN(cost_per_unit)?0:cost_per_unit)
    amount = quantity*cost_per_unit
    return amount
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show&&this.props.show!==newProps.show) {
      this.loadData(this.state.stockType,this.state.cat_id,this.state.sub_cat_id,1,this.state.defaultRows)
      this.loadWarehouse()
      this.loadCategory(this.state.stockType)
    }
  }

  loadData(stockType,cat_id,sub_cat_id,page=1,rowsData=20) {
    let that = this
    that.setState({loading:true,defaultRows:rowsData})
    let start = (page * rowsData) - rowsData
    if (page === 1) {
      start = 0
      that.setState({ activePage: page })
    }
    ReportStore.loadStockHasSubCatList(stockType, '', cat_id, sub_cat_id, start, rowsData, function(result) {
      const totalPage = result.total_count / rowsData
      that.setState({sum_cost:result.sum_cost,data:result.data,totalPage: Math.ceil(totalPage), loading:false})
    })  
  }

  loadExcelData(complete) {
    let that = this
    that.setState({loading:true})
    ReportStore.loadStockHasSubCatList(this.state.stockType, '', this.state.cat_id, this.state.sub_cat_id, '', '', function(result) {
      that.setState({dataExcel:result.data,loading:false})
      complete('OK')
    })
  }

  loadWarehouse() {
    let stocktypelists = [
      {label:'เครื่องมือช่าง',value:'tool'},
      {label:'อะไหล่ (ทั่วไป)',value:'genpart'},
      {label:'เบ็ตเตล็ด',value:'officemate'},
      {label:'สีรถยนต์',value:'color'}
    ]
    StockStore.loadWarehouse((result)=>{
      result.data.forEach((item,index)=>{
        stocktypelists.push({
          label:item.name,
          value:'genpart'+item.warehouse_id
        })
      })  
      this.setState({ stocktypelists: stocktypelists })
    })
  }

  loadCategory(stockType) {
    let categorys = [{label:'----- ทั้งหมด -----',value:'all'}]
    StockStore.loadCategory(stockType,(result) =>{
      result.data.forEach((item,index)=>{
        categorys.push({
          label:item.name,
          value:item.cat_id
        })
      })  
      this.setState({ categorys: categorys })
    })
  }

  loadSubCategory(value) {
    let that = this
    let {stockType} = this.state
    let sub_categorys = [{label:'----- ทั้งหมด -----',value:'all'}]
    StockStore.loadSubCategory(stockType, value, function (result) {
      result.data.forEach((item,index)=>{
        sub_categorys.push({
          label:item.name,
          value:item.cat_id
        })
      })  
      that.setState({ sub_categorys: sub_categorys })
    })
  }

  renderRowData() {
    let {data} = this.state
    if (data.length>0) {
      return(
        data.map((item, index) => {
          return(
            <tr key={index}>
              <td className='text-center'>{item.productcode}</td>
              <td className='text-left'>{item.description}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-center'>{item.unit}</td>
              <td className='text-right'>{this.getNumberFormat(item.cost_per_unit)}</td>
              <td className='text-right'>{this.getNumberFormat(this.getCostPerRow(item))}</td>
            </tr>
          )  
        })
      )
    } else {
      return(<tr><td colSpan={6}>{'ไม่พบข้อมูล'}</td></tr>)
    }  
  }

  renderTable() {
    let {activePage,totalPage} = this.state
    return(
      <div className="display-overflow">
        <table className="table table-responsive table-bordered-solid table-hover">
          <thead>
            <tr>
              <th style={{width:"100px"}} className="text-center">รหัสสินค้า</th>
              <th style={{width:"150px"}} className="text-center">ชื่ออะไหล่</th>
              <th style={{width:"100px"}} className="text-center">จำนวน</th>
              <th style={{width:"100px"}} className="text-center">หน่วยนับ</th>
              <th style={{width:"100px"}} className="text-center">ต้นทุน/หน่วย</th>
              <th style={{width:"100px"}} className="text-center">ต้นทุนทั้งหมด</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
          {totalPage===activePage?
          <tfoot>
            <tr>
              <th colSpan={5} className='text-right'>ยอดรวม</th>
              <th className='text-right'>{this.getNumberFormat(this.state.sum_cost)}</th>
            </tr>
          </tfoot>
          :''}
        </table>
      </div>
    )
  }

  renderExcelRowData() {
    let {dataExcel} = this.state
    if (dataExcel.length>0) {
      return(
        dataExcel.map((item, index) => {
          return(
            <tr key={index}>
              <td className='text-center'>{item.productcode}</td>
              <td className='text-left'>{item.description}</td>
              <td className='text-center'>{item.quantity}</td>
              <td className='text-center'>{item.unit}</td>
              <td className='text-right'>{this.getNumberFormat(item.cost_per_unit)}</td>
              <td className='text-right'>{this.getNumberFormat(this.getCostPerRow(item))}</td>
            </tr>
          )  
        })
      )
    } else {
      return(<tr><td colSpan={6}>{'ไม่พบข้อมูล'}</td></tr>)
    }  
  }

  renderExcelTable() {
    return(
      <div className="display-overflow" style={{display:'none'}}>
        <table id={this.refTableId} className="table table-responsive table-bordered-solid table-hover">
          <thead>
            <tr>
              <th style={{width:"100px"}} className="text-center">รหัสสินค้า</th>
              <th style={{width:"150px"}} className="text-center">ชื่ออะไหล่</th>
              <th style={{width:"100px"}} className="text-center">จำนวน</th>
              <th style={{width:"100px"}} className="text-center">หน่วยนับ</th>
              <th style={{width:"100px"}} className="text-center">ต้นทุน/หน่วย</th>
              <th style={{width:"100px"}} className="text-center">ต้นทุนทั้งหมด</th>
            </tr>
          </thead>
          <tbody>
            {this.renderExcelRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={5} className='text-right'>ยอดรวม</th>
              <th className='text-right'>{this.getNumberFormat(this.state.sum_cost)}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  onPageSelect(e) {
    this.setState({ activePage: e })
    this.loadData(this.state.stockType,this.state.cat_id,this.state.sub_cat_id,e,this.state.defaultRows)
  }

  onStockTypeChange(e) {
    this.setState({ stockType:e.value, activePage:1, cat_id:'all', sub_cat_id:'all' })
    this.loadData(e.value,'all','all',1,this.state.defaultRows)
    this.loadCategory(e.value)
  }

  onCategoryChange(e) {
    this.setState({ cat_id:e.value, activePage:1, sub_cat_id:'all' })
    this.loadData(this.state.stockType,e.value,'all',1,this.state.defaultRows)
    this.loadSubCategory(e.value)
  }

  onSubCategoryChange(e) {
    this.setState({ sub_cat_id:e.value, activePage:1 })
    this.loadData(this.state.stockType,this.state.cat_id,e.value,1,this.state.defaultRows)
  }


  onRowsPerPageChange(e) {
    let rows = e
    this.setState({ defaultRows:rows, activePage:1 })
    this.loadData(this.state.stockType,this.state.cat_id,this.state.sub_cat_id,1,rows)
  }

  onExportExcel(e) {
    this.loadExcelData((result)=>{
      if (result==='OK') {
        const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
        let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

        function s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        }    
        const fileName = 'รายงานสต็อกมูลค่าคงเหลือ.xlsx'
        FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName)
      }  
    })
  }

  onPrintTable(e) {
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url  = './?startPage=PrintReportStockBalanceValue&stock_type='+this.state.stockType+'&cat_id='+this.state.cat_id+'&sub_cat_id='+this.state.sub_cat_id
    } else{
      url = './pdf/v2/?startPage=PrintReportStockBalanceValue&stock_type='+this.state.stockType+'&cat_id='+this.state.cat_id+'&sub_cat_id='+this.state.sub_cat_id
    }
    this.refs.iframe.loadUrl(url)
  }
  
  renderToolbar() {
    return(
              <Form inline style={{marginBottom:'5px'}}>
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={this.state.stockType}
                    options={this.state.stocktypelists}
                    style={{ width: "200px" }}    
                    onChange={this.onStockTypeChange.bind(this)}
                  />
                </FormGroup>  
                {' '}
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={this.state.cat_id}
                    options={this.state.categorys}
                    style={{ width: "200px" }}    
                    onChange={this.onCategoryChange.bind(this)}
                  />
                </FormGroup>  
                {' '}
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={this.state.sub_cat_id}
                    options={this.state.sub_categorys}
                    style={{ width: "200px" }}    
                    onChange={this.onSubCategoryChange.bind(this)}
                  />
                </FormGroup>
                {' '}
                <FormGroup>
                  <Button                 
                    className='bg-maroon'
                    onClick={this.onPrintTable.bind(this)}
                  >
                    <FontAwesome name='print'/>&nbsp;พิมพ์เอกสาร
                  </Button>
                </FormGroup>
                {' '}
                <FormGroup>
                  <PrintButtons
                    width={''}
                    display={''}
                    marginLeft={''}
                    onExportExcel={this.onExportExcel.bind(this)}
                  />
                </FormGroup>
              </Form>
    )
  }

  renderPaging2() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev={'ก่อนหน้า'}
          next={'ถัดไป'}
          first={false}
          last={false}
          ellipsis
          boundaryLinks
          items={this.state.totalPage}
          maxButtons={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)}
        />  
      </div>
    )
  }

  renderPaging(){
    return (
      <div className="text-right">
        <Form inline>
          <FormGroup>
            จำนวนแถวต่อหน้า
          </FormGroup>  
          {' '}
          <FormGroup>
            <DropdownButton id='' bsStyle={'default'} title={this.state.defaultRows} onSelect={this.onRowsPerPageChange.bind(this)}>
              {this.state.optionsRows.map((item,index)=>(
                <MenuItem key={index} eventKey={item}>{item}</MenuItem>  
              ))}
            </DropdownButton>
          </FormGroup> 
          {' '} 
          <FormGroup style={{lineHeight:'10px'}}>
            <Pagination
                prev={'ก่อนหน้า'}
                next={'ถัดไป'}
                first={false}
                last={false}
                ellipsis
                boundaryLinks
                items={this.state.totalPage}
                maxButtons={5}
                activePage={this.state.activePage}
                onSelect={this.onPageSelect.bind(this)}
            />
          </FormGroup>  
        </Form>  
    </div>
    )
  }

  render() {
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderTable()}
          {this.renderExcelTable()}
          {this.renderPaging()}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportStockBalanceValue.defaultProps = {
  show : false
}

export default ReportStockBalanceValue;


// WEBPACK FOOTER //
// ./src/view/report/stock/ReportStockBalanceValue.js